// Things in here should only be used in the admin app, usually because
// there either isn't a polyfill available or we decided not to use one

// IOS 9 and IE < 11 don't have Intl at all
const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
})

export const formatUSD = amt => amt ? usdFormatter.format(amt) : null

/** Format a Date as YYYY-MM-DD. */
export const toDateStr = d => d.toISOString().slice(0, 10)

/** Return a Date that is `days` days before now. */
export const daysAgo = days => new Date(Date.now() - days * 86400000)

/** Set a query parameter on URLSearchParams, skipping null/empty values. */
export const setQueryParam = (params, key, val) => {
  if (val == null || val === "") return
  const str = typeof val === "boolean" ? (val ? "1" : "0") : String(val)
  params.set(key, str)
}

/** Append a wildcard glob suffix to a filter value unless one already exists. */
export const globParam = (v) => v.includes("*") || v.includes("?") ? v : v + "*"

/** Format an ISO datetime string as "YYYY-MM-DD HH:MM:SS". */
export const formatDateTime = (s) => s ? new Date(s).toISOString().replace("T", " ").slice(0, 19) : "—"

/** Format an ISO date string as "YYYY-MM-DD". */
export const formatDate = (s) => s ? new Date(s).toISOString().slice(0, 10) : "—"
